function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#20ad9b;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M1.5,31.5h33L18,3Zm18-4.5h-3V24h3Zm0-6h-3V15h3Z",
  transform: "translate(-1.5 -3)"
});

const SvgIconAdverseEvent = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28.5,
    viewBox: "0 0 33 28.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAdverseEvent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_AdverseEvent.c3ea667f.svg";
export { ForwardRef as ReactComponent };